import React from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import gql from 'graphql-tag';
import { useQuery, useMutation } from '@apollo/react-hooks';
import moment from 'moment';

import Block from 'components/common/block';
import { ReactComponent as TrashIcon } from 'assets/vectors/remove-16px.svg';
import { ReactComponent as AddIcon } from 'assets/vectors/add-green-16px.svg';
import { ReactComponent as HoseIcon } from 'assets/vectors/hoseIcon.svg';

import HosesModal from './hosesModal';

const ArchiveStsProjectEquipment = gql`
  mutation ArchiveStsProjectEquipment($input: ArchiveStsProjectEquipmentInput!) {
    archiveStsProjectEquipment(archiveStsProjectEquipmentData: $input) {
      success
    }
  }
`;

const GetHoses = gql`
  query StsProjectEquipments ($sortBy: [String], $stsprojectId: ID){
    stsprojectEquipments(sortBy: $sortBy, stsprojectId: $stsprojectId) {
      edges {
        node {
          id
          hose {
            id
            plNumber
            serialNumber
            diameter
            length
            location
            expireDate
            status
          }
        }
      }
    }
  }
`;

function Hoses({ projectId, onAdd, allowEdit }) {
  const [showHosesModal, setShowHosesModal] = React.useState(false);

  const {data, refetch} = useQuery(GetHoses, {
    variables: {
      stsprojectId: projectId,
      sortBy: ['created desc']
    },
    onError(e) {
      console.log(e);
    }
  });

  const [executeArchiveStsProjectEquipment, { loading: archiveLoading }] = useMutation(ArchiveStsProjectEquipment, {
    onCompleted() {
      refetch();
    }
  });

  function addHose() {
    setShowHosesModal(true);
  }

  function removeHose(equipmentId) {
    executeArchiveStsProjectEquipment({
      variables: {
        input: {
          stsprojectEquipmentId: equipmentId,
        }
      }
    })
  }

  const projectEquipments = data ? data.stsprojectEquipments.edges.map(r => r.node).filter(r => !!r.hose) : [];
  const addedHoses = projectEquipments.map(r => r.hose.id);

  return (
    <StyledBlock title={<BlockTitle><HoseIcon style={{ marginRight: '8px'}} /> Hoses</BlockTitle>}>
      <TableContainer>
        <Table aria-label="simple table" style={{ whiteSpace: 'nowrap' }}>
          <TableHead>
            <TableRow>
              <TableCell>
                PL Nr.
              </TableCell>
              <TableCell>
                Serial Nr.
              </TableCell>
              <TableCell>
                Diameter
              </TableCell>
              <TableCell>
                Length
              </TableCell>
              <TableCell>
                Location
              </TableCell>
              <TableCell>
                Expire date
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
          {
              !projectEquipments.length
                ? <TableRow>
                    <TableCell>None added</TableCell>
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                  </TableRow>
                : (
                  projectEquipments.map(equipment => (
                    <TableRow key={equipment.id}>
                      <TableCell>
                        <Link href={`/dashboard/equipment/hoses/${equipment.hose.id}`} target="_blank">{equipment.hose.plNumber}</Link>
                      </TableCell>
                      <TableCell>
                        {equipment.hose.serialNumber}
                      </TableCell>
                      <TableCell>
                        {equipment.hose.diameter}
                      </TableCell>
                      <TableCell>
                        {equipment.hose.length}
                      </TableCell>
                      <TableCell>
                        {equipment.hose.location}
                      </TableCell>
                      <TableCell>
                        {equipment.hose.expireDate ? moment(equipment.hose.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null}
                      </TableCell>
                      <TableCell align="right">
                        {
                          allowEdit && (
                            <IconButton
                              onClick={() => removeHose(equipment.id)}
                              aria-label="delete hose"
                              className="deleteButton"
                              disabled={archiveLoading}
                            >
                              <TrashIcon />
                            </IconButton>
                          )
                        }
                      </TableCell>
                    </TableRow>
                  ))
                )
            }
          </TableBody>
        </Table>
      </TableContainer>
      {
        allowEdit && (
          <ButtonWrapper>
            <Button
              variant="outlined"
              color="primary"
              onClick={addHose}
              endIcon={<AddIcon />}
            >
            Add hose
            </Button>
          </ButtonWrapper>
        )
      }
      { showHosesModal && <HosesModal setShowHosesModal={setShowHosesModal} projectId={projectId} refetch={refetch} addedHoses={addedHoses} onAdd={onAdd} /> }
    </StyledBlock>
  );
}

const BlockTitle = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.textColor};
`;

const StyledBlock = styled(Block)`
  width: 1080px;
  max-width: 100%;
  margin-bottom: 16px;
`;

const Link = styled.a`
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: none;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  @media (${props => props.theme.breakpoints.tablet}) {
    justify-content: flex-start;
  }
`;

export default Hoses;
